import { toast } from "../hooks/useToast";

// Extensões de arquivo de modelo/impressão aceitas nos produtos.
export const EXTENSOES_3D = ["stl", "gcode", "3mf", "obj", "zip"];

// Todo .3mf é um ZIP (assinatura "PK" nos primeiros bytes). O Bambu Studio
// às vezes exporta o resultado do fatiamento como um 3mf-com-gcode-embutido
// mas com a extensão ".gcode" — dá pra reconhecer isso sem depender do nome.
export async function ehGcodeDisfarcadoDe3mf(file) {
  const head = new Uint8Array(await file.slice(0, 4).arrayBuffer());
  return head.length >= 2 && head[0] === 0x50 && head[1] === 0x4b;
}

export function temArquivo3mfValido(arquivos) {
  return (arquivos || []).some(a => (a.nome || "").toLowerCase().endsWith(".3mf"));
}

// Baixa um arquivo do Storage. Usa fetch primeiro (pra forçar o nome certo
// no download) — mas fetch() falha ("Failed to fetch") tanto pra arquivo
// realmente inexistente quanto por bloqueio de CORS/rede, e não dá pra
// diferenciar os dois casos dali. Por isso, se o fetch em si quebrar (não
// respondeu, não é um HTTP 404 de verdade), cai pra navegação direta na URL
// — isso não é bloqueado por CORS e funciona se o arquivo realmente existir.
export async function baixarArquivo(url, nome) {
  let resp;
  try {
    resp = await fetch(url);
  } catch {
    window.open(url, "_blank");
    return;
  }
  if (!resp.ok) {
    toast(`Erro ao baixar "${nome}": ${resp.status === 404
      ? "arquivo não encontrado no Storage (foi apagado ou o upload não terminou)"
      : `HTTP ${resp.status}`}`, "error");
    return;
  }
  try {
    const blob = await resp.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = nome || "arquivo";
    a.click();
    URL.revokeObjectURL(a.href);
  } catch (e) {
    toast(`Erro ao baixar "${nome}": ${e.message}`, "error");
  }
}

// Abre um .3mf direto no Bambu Studio. O protocolo bambustudio://open?file=
// existe mas o próprio Bambu Studio só aceita baixar de domínios da
// MakerWorld — qualquer outra origem (Firebase Storage incluso) falha com
// "A importação para o Bambu Studio falhou". No app desktop (Electron) o
// processo principal baixa o arquivo e abre com a associação de arquivo do
// Windows (mesmo efeito de dar duplo-clique no .3mf baixado). Fora do
// Electron não tem contorno — só baixar (via baixarArquivo) e abrir manualmente.
export async function abrirNoBambuStudio(fileUrl, nomeArquivo) {
  if (window.electronAPI?.abrirArquivoLocal) {
    const res = await window.electronAPI.abrirArquivoLocal(fileUrl, nomeArquivo);
    if (res?.ok) return;
    toast(`Não deu pra abrir "${nomeArquivo}" no Bambu Studio: ${res?.error || "erro desconhecido"}`, "error");
    return;
  }
  await baixarArquivo(fileUrl, nomeArquivo);
}
